import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-down-tail', 'ArrowDownTail', [["path",{"d":"M12 6v15"}],["path",{"d":"M9 18l3 3l3 -3"}],["path",{"d":"M9 3l3 3l3 -3"}]]);